var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (i18n, id, videoEmbed, videoId) {
      pug_html = pug_html + "\u003Cdiv" + (" class=\"modal fade\""+pug.attr("id", id, true, true)+" tabindex=\"-1\"") + "\u003E\u003Cdiv class=\"modal-dialog modal-xl modal-dialog-centered\"\u003E\u003Cdiv class=\"modal-content\"\u003E\u003Cdiv class=\"modal-body px-0 py-0\"\u003E\u003Cdiv class=\"ratio ratio-16x9\"\u003E";
if (videoId) {
pug_html = pug_html + "\u003Ciframe" + (" width=\"560\" height=\"315\""+pug.attr("src", `https://www.youtube-nocookie.com/embed/${videoId}`, true, true)+pug.attr("title", i18n.modal_video_title, true, true)+" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\""+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E";
}
else
if (videoEmbed) {
pug_html = pug_html + (null == (pug_interp = videoEmbed) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "videoEmbed" in locals_for_with ?
        locals_for_with.videoEmbed :
        typeof videoEmbed !== 'undefined' ? videoEmbed : undefined, "videoId" in locals_for_with ?
        locals_for_with.videoId :
        typeof videoId !== 'undefined' ? videoId : undefined));
    ;;return pug_html;}

module.exports = template